import $ from 'jquery';

/**
 * @returns {HTMLElement}
 */
function getRobotsMetaTag() {
    return $('meta[name=robots]')[0];
}

/**
 * The original value of the `<meta name="robots">` HTML tag
 *
 * @type {string|null}
 */
let originalRobotsMetaTagContent = null;

/**
 * @param {string} content The content to set in the robots tag
 */
export function setRobotsMetaTag(content) {
    let robotsTag = getRobotsMetaTag();
    if (!robotsTag) {
        robotsTag = document.createElement('meta');
        robotsTag.name = 'robots';
        window.document.head.appendChild(robotsTag);
    }

    robotsTag.setAttribute('content', content);
}

/**
 * Restores the `<meta name="robots" content="<values>"` tag to what it was when the page loaded.
 * If there was no robots meta tag, then it will be removed.
 */
export function restoreRobotsMetaTag() {
    const robotsMetaTag = getRobotsMetaTag();
    if (robotsMetaTag) {
        if (originalRobotsMetaTagContent === null || originalRobotsMetaTagContent === undefined) {
            robotsMetaTag.remove();
        } else {
            robotsMetaTag.content = originalRobotsMetaTagContent;
        }
    }
}

/**
 * Caches off the original value of the `<meta name="robots">` HTML tag
 */
function cacheOriginalRobotsMetaTag() {
    const robotsMetaTag = getRobotsMetaTag();
    if (robotsMetaTag) {
        originalRobotsMetaTagContent = robotsMetaTag.content;
    }
}

cacheOriginalRobotsMetaTag();
